import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/successIcom.png'
import _imports_1 from '@assets/images/backIcon.png'


const _hoisted_1 = { class: "passGrad-container" }
const _hoisted_2 = { class: "grad-inner" }
const _hoisted_3 = { class: "grad-body" }
const _hoisted_4 = { class: "font-DIN" }
const _hoisted_5 = {
  class: "grad-btn-container flex-row",
  style: {"justify-content":"flex-end"}
}
const _hoisted_6 = { class: "btn-box" }


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    allPassTime: {
        type: Number,   
        default: 0
    },
},
  emits: ['onBack', 'onRestart'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit




return (_ctx: any,_cache: any) => {
  const _component_vkn_button = _resolveComponent("vkn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, [
        _createElementVNode("span", null, "成绩")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "恭喜你通过测试", -1)),
        _createElementVNode("span", null, [
          _cache[2] || (_cache[2] = _createTextVNode("用时 ")),
          _createElementVNode("span", _hoisted_4, _toDisplayString(props.allPassTime), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_vkn_button, {
            label: "重新开始",
            type: "tertiary",
            size: "medium",
            onClick: _cache[0] || (_cache[0] = ()=>{emits('onRestart', false)})
          }, {
            icon: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_vkn_button, {
            label: "返回",
            type: "tertiary",
            size: "medium",
            onClick: _cache[1] || (_cache[1] = ()=>{emits('onBack')})
          }, {
            icon: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("img", { src: _imports_1 }, null, -1)
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})